import { render, staticRenderFns } from "./MiniAppRuiDiTuiActivityEdit.vue?vue&type=template&id=05421ada&scoped=true&"
import script from "./MiniAppRuiDiTuiActivityEdit.vue?vue&type=script&lang=js&"
export * from "./MiniAppRuiDiTuiActivityEdit.vue?vue&type=script&lang=js&"
import style0 from "./MiniAppRuiDiTuiActivityEdit.vue?vue&type=style&index=0&id=05421ada&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05421ada",
  null
  
)

export default component.exports